module.exports = __webpack_public_path__ + "aa30afba122908ddaaafc4294a1b681f.jpg";